import * as React from "react";
import PropTypes from "prop-types";
import PercentageNumber from "./PercentageNumber";

const RRoR = ({ rrorValue }) => {
  if (rrorValue < 0) {
    return "0%";
  }
  return <PercentageNumber value={rrorValue} showSign={true} />;
};

RRoR.propTypes = {
  rrorValue: PropTypes.number.isRequired,
};

export default RRoR;



// WEBPACK FOOTER //
// ./src/components/UI/RRoR.jsx